`<template lang="pug">
  .changes-row-wrap
    .changes-row-wrap__date {{ getDate(changesData) | dateShortFormat }}
    .changes-row-wrap__container
      record-changes-row(
        v-for='item of changesData'
        :key='item.id + item.type'
        :item="item"
      )
</template>

<script>

import RecordChangesRow from '@/components/record-details/modifications/RecordChangesRow'
import { timeFormat, } from '@/store/helpers.js'

export default {
  name: 'RecordChangesWrap',
  components: {
    RecordChangesRow,
  },
  props: {
    changesData: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getDate (data) {
      return data[0] ? timeFormat(data[0].date) : null
    },
  },
}
</script>

<style scoped lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .changes-row-wrap
    display flex
    width: 100%
    &__date
      width 20%
      color $default-color-bold-1
      padding 10px 10px 0 35px
      font-weight 700
      position relative
      border-left 2px solid $default-color-light-1
      &::before
        content ''
        position absolute
        top 10px
        left -9px
        transform: rotate(45deg);
        display inline-block
        width 16px
        height 16px
        border-radius 2px
        background: $default-color-bold-1
    &__container
      margin-bottom: 25px
      width 80%

  @media (max-width: $tablet)
    .changes-row-wrap
      display block
      width: 100%
      &__date
        display none
        margin-bottom: 0
      &__container
        width 100%

</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/RecordChangesWrap.vue